import { Component } from 'react';
import { Svg } from '../Gauge';
import { formatLabel, formatLabelIdAndId, GaugeCoordinates, GaugeElementId, updateLabelColorById, updateLabelTextById } from '../shared/GaugeShared';

export interface BoundSettings {
   coordinates: GaugeCoordinates;
   elementId: GaugeElementId;
}

export interface GaugeBoundLabelProps {
   svg: Svg;
   svgId: string;
   upperBound: number;
   lowerBound: number;
   labelsColor: string;
   prePendCharacter: string;
   postPendCharacter: string;
}

export class GaugeBoundLabel extends Component<GaugeBoundLabelProps> {
   private BOUND_LABEL_SIZE = 10;
   private BOUND_LABEL_WEIGHT = 'bold';
   private UPPER_BOUND_LABEL_SETTINGS: BoundSettings = {
      coordinates: {
         x: 49,
         y: 8
      },
      elementId: GaugeElementId.UPPER_BOUND_LABEL
   };
   private LOWER_BOUND_LABEL_SETTINGS: BoundSettings = {
      coordinates: {
         x: 49,
         y: 90
      },
      elementId: GaugeElementId.LOWER_BOUND_LABEL
   };

   constructor(props: GaugeBoundLabelProps) {
      super(props);

      this.drawBoundLabel(props, this.UPPER_BOUND_LABEL_SETTINGS);
      this.drawBoundLabel(props, this.LOWER_BOUND_LABEL_SETTINGS);
   }

   render(): null {
      return null;
   }

   UNSAFE_componentWillReceiveProps(nextProps: GaugeBoundLabelProps): void {
      this.updateBoundLabel(nextProps, GaugeElementId.UPPER_BOUND_LABEL);
      this.updateBoundLabel(nextProps, GaugeElementId.LOWER_BOUND_LABEL);
   }

   drawBoundLabel = (props: GaugeBoundLabelProps, settings: BoundSettings): void => {
      props.svg.draw.text(formatLabel(this.getBoundValueBasedOnType(props, settings.elementId),
                                      props.prePendCharacter,
                                      props.postPendCharacter))
         .move(settings.coordinates.x, settings.coordinates.y)
         .attr({
                  id: formatLabelIdAndId(settings.elementId, props.svgId)
               })
         .font({
                  fill: props.labelsColor,
                  size: this.BOUND_LABEL_SIZE,
                  weight: this.BOUND_LABEL_WEIGHT,
                  anchor: 'end',
                  family: 'sans-serif'
               });
   };

   getBoundValueBasedOnType = (props: GaugeBoundLabelProps, elementId: GaugeElementId): number => {
      return elementId === GaugeElementId.UPPER_BOUND_LABEL ? props.upperBound : props.lowerBound;
   };

   updateBoundLabel = (props: GaugeBoundLabelProps, elementId: GaugeElementId): void => {
      updateLabelTextById(formatLabelIdAndId(elementId, props.svgId),
                          formatLabel(this.getBoundValueBasedOnType(props, elementId),
                                      props.prePendCharacter,
                                      props.postPendCharacter));
      updateLabelColorById(formatLabelIdAndId(elementId, props.svgId), props.labelsColor);
   };
}
